export { MSALLoginButton } from './web/MSALLoginButton'
export { useMSALLogin } from './web/useMSALLogin'

export * from './node'

export { AuthMSALReactFeature as default } from './AuthMSALReactFeature'
